var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M21.6 16L7.3 30.3l1.4 1.4L24.4 16 8.7.3 7.3 1.7"})));
}

ChevronRight.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
